<template>
  <div>
    <GastosCategoriaSelect
      @process-categoria="setCategoriaRegister"
      @clearable="removeCategoria"
      :categoria="egreso.categoria"
      :outlined="true"
    ></GastosCategoriaSelect>
  </div>
</template>

<script>
import TreeCategoria from "@/views/categorias/consultar/TreeCategoria.vue";
import CategoriaSelect from "@/components/categorias/consultar/categoria.select.vue"
import GastosCategoriaSelect from '@/views/pos/egresos/components/GastosCategoriaSelect.vue'

export default {
  name: "EgresoFormCategoria",
  components: {
    TreeCategoria,
    GastosCategoriaSelect,
  },


  props: {
    egreso: {
      type: Object,
      required: true,
    },
  },


  methods: {
    removeCategoria(){
      this.egreso.categoriaArbol = null
      this.$emit("set_categoria", null);

    },
    setCategoriaRegister(cat) {
      console.log("this.egreso.categoriaArbol = ",cat);
      this.egreso.categoria = cat;
      this.$emit("set_categoria", cat);
    },
  },
};
</script>

<style lang="scss" scoped></style>
